<div class="m-auto mt-5 md:w-9 sm:w-full">
    <p-steps [model]="steps" [readonly]="true"></p-steps>
</div>
<div class="flex flex-column flex-wrap align-content-center align-items-center my-auto">
    <h3 class="mt-5">Crear un nuevo perfil</h3>
    <p-messages key="user" [closable]="false" class="w-6 mb-5"></p-messages>
    <form [formGroup]="userForm" (ngSubmit)="navigateToPersonRegistration()" class="w-6">
        <div class="field mb-5">
            <span class="p-input-icon-right p-float-label w-full">
                <i *ngIf="this.userForm.status ==='PENDING'" class="pi pi-spin pi-spinner"></i>
                <input type="text" id="username" pInputText class="p-inputtext-lg w-full" formControlName="username"
                    maxlength="10" minlength="10" autofocus="true"
                    [class.ng-invalid]="this.userForm.get('username')?.invalid && this.userForm.get('username')?.touched" />
                <label htmlFor="username">Número celular</label>
            </span>
        </div>
        <div class="field mb-5">
            <span class="p-float-label">
                <p-password id="password" formControlName="password" [feedback]="false"
                    maxlength="20" minlength="6" class="w-full" inputStyleClass="w-full p-inputtext-lg" styleClass="w-full"
                    [class.ng-invalid]="this.userForm.get('password')?.invalid && this.userForm.get('password')?.touched"></p-password>
                    <label htmlFor="password">Contraseña</label>
                </span>
                <p class="error-message" *ngIf="this.userForm.get('password')?.errors?.['minlength'] && this.userForm.get('password')?.touched">
                    La contraseña debe tener al menos 6 caracteres.
                </p>
        </div>
        <div class="flex flex-column align-items-center my-4 gap-3">
            <p-button label="Continuar registro" type="submit" [disabled]="userForm.invalid || userForm.pending"></p-button>
            <p-button class="grey" label="Servicio al cliente" icon="pi pi-question-circle" (onClick)="contactUs()" ariaLabel="Servicio al cliente"></p-button>
        </div>
    </form>
    <p>¿Ya tienes cuenta? <a class="link" label="Iniciar sesión" [routerLink]="['/ingresar']">Ingresar</a></p>
</div>